import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import { useAuth } from '../providers/AuthProvider';
import { checkAuthFromCookie, redirectToLogin } from '../../resources/login/operations';
import { useIdentifyUserInUserpilot } from '../analytics/userpilot-hooks';

export const Restricted = (props: { children: JSX.Element }) => {
    const { isAuthenticated, login, logout, markAsImpersonated } = useAuth();
    const { pathname } = useLocation();

    // Identify user in Userpilot once when authenticated
    useIdentifyUserInUserpilot();

    useEffect(() => {
        if (!checkAuthFromCookie(login, logout, markAsImpersonated, isAuthenticated)) {
            redirectToLogin(pathname);
        }
    }, [pathname, isAuthenticated, markAsImpersonated, login, logout]);

    return props.children;
};
